import { render, staticRenderFns } from "./TruckIcon.vue?vue&type=template&id=33e7c45a&"
import script from "./TruckIcon.vue?vue&type=script&lang=js&"
export * from "./TruckIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports